var tp = {
  post: {
    backurl: 'Post',
    countGallary: 18,
    items: [
      {
        id: "id",
        type: "label",
        title: '#',
        cols: "8",
        val: ""
      },
      {
        groups: [
          {
            id: "status",
            type: "select",
            isRequired: true,
            locale: 'lang.dict.status',
            invalidTooltip: '',
            cols: "2",
            optcate: "DefStatus",
            val: ""
          },
          {
            id: "category",
            type: "select",
            isRequired: true,
            locale: 'lang.dict.category',
            invalidTooltip: '',
            cols: "2",
            optcate: "categorylist",
            val: ""
          }
        ]
      },
      {
        id: "tags",
        type: "tagsinput",
        isRequired: true,
        maxlength: 200,
        locale: 'lang.dict.tags',
        invalidTooltip: '',
        tag: '',
        valueMode: 'text',
        cols: "12",
        optcate: "taglist"
      },
      {
        id: "title",
        type: "textbox",
        locale: 'lang.dict.title',
        isRequired: true,
        maxlength: 200,
        invalidTooltip: '',
        prefix: '',
        suffix: '',
        cols: "12",
        val: ""
      },
      {
        id: "subtitle",
        type: "textbox",
        locale: 'lang.dict.subtitle',
        isRequired: false,
        show: true,
        maxlength: 200,
        invalidTooltip: '',
        prefix: '',
        suffix: '',
        cols: "12"
      },
      {
        id: "preface",
        type: "textarea",
        locale: 'lang.dict.preface',
        isRequired: false,
        show: true,
        maxlength: 4000,
        rows: 2,
        invalidTooltip: '',
        cols: "12",
        val: ""
      },
      {
        id: "body",
        type: "textarea",
        locale: 'lang.dict.body',
        isRequired: false,
        maxlength: 4000,
        rows: 4,
        invalidTooltip: '',
        cols: "12",
        val: ""
      },
      {
        id: "summary",
        type: "textarea",
        locale: 'lang.dict.summary',
        isRequired: false,
        show: true,
        maxlength: 4000,
        rows: 4,
        invalidTooltip: '',
        cols: "12",
        val: ""
      }
    ],
    areas: [
      {
        name: "details",
        locale: 'lang.dict.details',
        groups: [
          {
            name: "paragraph",
            locale: 'lang.dict.paragraph',
            items: [
              {
                id: "paragraph",
                type: "paragraphs",
                isRequired: false,
                maxlength: 200,
                countGallary: 9,
                showOrder: true,
                showTitle: true,
                showBody: true,
                seq: 1,
                rows: 2,
                cols: "12",
                paragraphs: []
              }
            ]
          }
        ]
      }
    ]
  }
};
export default tp;
